import _ from 'lodash';
import { lsApiService, lsErrorService } from 'ls-vue-common';
import {
  SERVICE_HISTORY__RESET,
  SERVICE_HISTORY__GET_SCHEDULE,
  SERVICE_HISTORY__MUTATE_SCHEDULE,
  SERVICE_HISTORY__MUTATE_LOADING_STATUS,
  SERVICE_HISTORY__FILTER_SCHEDULE_EVENT,
} from '@/store/types';
import { lsModuleHelpers } from '../helpers';

const createInitialState = () => {
  return {
    loadingStatus: {
      isLoading: false,
    },
    schedule: {},
  };
};

export const mutations = {
  [SERVICE_HISTORY__RESET](state) {
    lsModuleHelpers.resetState({ state, createInitialState });
  },
  [SERVICE_HISTORY__MUTATE_SCHEDULE](state, payload) {
    state.schedule = payload;
  },
  [SERVICE_HISTORY__MUTATE_LOADING_STATUS](state, payload) {
    _.assign(state.loadingStatus, payload);
  },
};

export const actions = {
  [SERVICE_HISTORY__GET_SCHEDULE]({ commit, rootState }, { property_id, schedule_id }) {
    commit(SERVICE_HISTORY__MUTATE_LOADING_STATUS, {
      isLoading: true,
    });
    const { customer_id } = rootState.auth.user;

    return lsApiService
      .request({
        method: 'GET',
        route: `/customers/${customer_id}/properties/${property_id}/schedules/${schedule_id}`,
        params: {
          include: [
            'property',
            'schedulable',
            'scheduleevents.contractor.user',
            'scheduleevents.reviews',
            'scheduleevents.longgrasses',
            'scheduleevents.longGrassQuote.instantQuote',
            'scheduleevents.longGrassQuote.returnAvailabilities',
            'scheduleevents.longGrassQuote.serviceScheduleEvent',
            'scheduleevents.longGrassQuoteService.instantQuote',
            'scheduleevents.longGrassQuoteService.returnAvailabilities',
            'scheduleevents.longGrassQuoteService.serviceScheduleEvent',
          ],
        },
      })
      .then(({ data }) => {
        commit(SERVICE_HISTORY__MUTATE_SCHEDULE, data);
      })
      .catch((error) => {
        lsErrorService.log({ error, showAlert: true });
      })
      .finally(() => {
        commit(SERVICE_HISTORY__MUTATE_LOADING_STATUS, {
          isLoading: false,
        });
      });
  },
};

export const getters = {
  [SERVICE_HISTORY__FILTER_SCHEDULE_EVENT]: (state) => (scheduleEventId) => {
    const events = state.schedule.scheduleevents || [];
    return events.find((e) => e.id === parseInt(scheduleEventId)) || {};
  },
};

export const serviceHistory = {
  state: createInitialState,
  mutations,
  actions,
  getters,
};
